// Yasal sayfalarda ve footer'da kullanılan firma bilgileri (PayTR canlı mod gereksinimleri)
export const COMPANY = {
  brand: "365Rez",
  legalName: "ELC TEKNOLOJİ SANAYİ VE TİCARET LİMİTED ŞİRKETİ",
  address: "Gürselpaşa Mah. 75289 Sk. A Blok No:1/1 İç Kapı No:8 Seyhan / ADANA",
  taxOffice: "Seyhan",
  taxNumber: "3311584379",
  phone: "0532 270 51 74",
  phoneHref: "tel:+905322705174",
  email: "info@elcteknoloji.com",
  website: "https://365rez.com",
  websiteLabel: "365rez.com",
};

export const LEGAL_LINKS = [
  { to: "/iletisim", label: "İletişim" },
  { to: "/mesafeli-satis-sozlesmesi", label: "Mesafeli Satış Sözleşmesi" },
  { to: "/teslimat-kosullari", label: "Teslimat Koşulları" },
  { to: "/iptal-iade-kosullari", label: "İptal ve İade Koşulları" },
  { to: "/gizlilik-kvkk", label: "Gizlilik ve KVKK" },
];
